import Icons from "@/src/components/Icons";
import { reportApi } from "@/src/utils/api/report";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FilterDays from "./FilterDays";
import ScoreItem from "./ScoreItem";
import TotalScoreItem from "./TotalScoreItem";

function ReportScore() {
  let history = useNavigate();
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);

  const [data, setData] = useState<any>([]);
  const [from, setFrom] = useState<number>(startOfToday.getTime());
  const [to, setTo] = useState<number>(endOfToday.getTime());
  const [showFilter, setShowFilter] = useState<string>("امروز");
  
  useEffect(() => {
    reportApi.score(from, to).then((res) => {
      setData(res.data);
      console.log(data);
    });
  }, [from, to]);
  
  return (
    <div>
      <h4
        className="title text-xl font-extrabold flex items-center cursor-pointer"
        onClick={() => history("/report")}
      >
        <Icons name="arrowBack" fill="none" size={40} />
        امتیاز
      </h4>
      <FilterDays
        setFrom={setFrom}
        setTo={setTo}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
      />

      <div className="items flex flex-col gap-4 mt-6">
        {/* Add the TotalScoreItem at the top */}
        {data && data.length > 0 && (
          <TotalScoreItem data={data} />
        )}
        <hr className="text-gray-100-mmpz" />
        {/* Render individual food items */}
        {data &&
          data.length > 0 &&
          data.map((item: any, index: number) => {
            return <ScoreItem key={index} data={item} />;
          })}
      </div>
    </div>
  );
}

export default ReportScore;